import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../config');

class ModalViewPatient extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			gr_rh:"",
			patient:"",
			expedient:"",
			center_send:"",
			health_service:"",
			units_delivered:[]
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	handleShow(id, folio){
		
		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'unit_delivered/by_folio?petition_id='+id+"&folio="+folio,{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		}).then(res => {
			this.props.waiting.handleClose();
	    	if(res.ok){
	          	return res.json();
	        }else{
	          	res.text().then(function(result) {
	            	swal('¡Error', result, 'error');
	          	});
        	}
        	
        }).then(response => {
			if(response !== undefined){
				this.setState({
					gr_rh:response.patient_group+
						(response.patient_rh === 'POSITIVO' ? '+' 
						:response.patient_rh === 'NEGATIVO' ? '-' : ''),
					patient:response.patient_name,
					expedient:response.expedient,
					center_send:response.center_sent,
					health_service:response.health_services,
					units_delivered:response.units_delivered,
					show:true
				})

			   
			}

		})
	}

	handleClose(){
		this.setState({
			show: false,
			gr_rh:"",
			patient:"",
			expedient:"",
			center_send:"",
			health_service:"",
			units_delivered:[]
		});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal bsSize='lg' show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles Paciente</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
	        			<div className="col-xs-12">
		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Paciente</span>
		        				<input type="text" className="form-control" value={this.state.patient} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Grupo & RH</span>
		        				<input type="text" className="form-control" value={this.state.gr_rh} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Expediente</span>
		        				<input type="text" className="form-control" value={this.state.expedient} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Centro Distribuidor</span>
		        				<input type="text" className="form-control" value={this.state.center_send} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-6">
		        				<span className="span-min">Servicio</span>
		        				<input type="text" className="form-control" value={this.state.health_service} disabled/>
		        			</div>
		        		</div>
		        		<div className="col-xs-12">
		        			<fieldset>
			        			<legend>Unidades </legend>
			        			<Table responsive hover>
			        				<thead>
					                  	<tr>
						                    <th>Folio</th>
						                    <th>Fecha</th>
						                    <th>Unidad</th>
						                    <th>Componente</th>
						                    <th>Volumen</th>
						                    <th>Grupo & RH</th>
						                    <th>Caducidad</th>
					                  	</tr>
					                </thead>
					                <tbody>
					                 	{this.state.units_delivered.map( (unit, index) => (
					                    	<tr key={index}>
					                      		<td>{unit.folio}</td>
						                      	<td>
						                      		{moment(unit.register_date).format('DD/MM/YYYY')+' '+
						                      		moment(unit.register_hour, 'HH:mm:ss').format('HH:mm')}
						                      	</td>
						                      	<td>{unit.unit.unit_number}</td>
						                      	<td>{unit.component}</td>
						                      	<td>{unit.unit.volume} </td>
						                      	<td>{unit.unit.group+(unit.unit.rh === 'POSITIVO' ? '+':
						                      		unit.unit.rh === 'NEGATIVO' ? '-' : '')}</td>
						                      	<td>{moment(unit.unit.caducidad).format('DD/MM/YYYY HH:mm')}</td>
					                    	</tr>
					                  	))}
					                </tbody>
			        			</Table>
			        		</fieldset>
		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>

		)
	}

} 

export default translate('translations') (ModalViewPatient);